import React from 'react';
import { Button } from 'antd';
const CloseTagIcon = ({ style, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 22 22"
        fill="none"
        style={{ color: 'inherit', ...style }}
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
            d="M20.9886 6.15385C20.9886 4.96923 19.9601 4 18.7032 4H8.69319C7.34481 4 6.07642 4.55998 5.20797 5.52921L1.53992 9.61076C0.820026 10.4185 0.820026 11.5923 1.53992 12.3892L5.20797 16.4708C6.07642 17.44 7.35623 18 8.69319 18H18.7146C19.9716 18 21 17.0308 21 15.8462V6.15385H20.9886ZM17.092 13.0569C17.4691 13.4123 17.4691 13.9723 17.092 14.3277C16.9092 14.5 16.6578 14.5861 16.4178 14.5861C16.1778 14.5861 15.9264 14.5 15.7436 14.3277L13.5611 12.2708L11.3785 14.3277C11.1957 14.5 10.9443 14.5861 10.7043 14.5861C10.4644 14.5861 10.213 14.5 10.0301 14.3277C9.65305 13.9723 9.65305 13.4123 10.0301 13.0569L12.2127 11L10.0301 8.94307C9.65305 8.58769 9.65305 8.0277 10.0301 7.67231C10.3958 7.31693 11.0014 7.31693 11.3785 7.67231L13.5611 9.72924L15.7436 7.67231C16.1093 7.31693 16.7149 7.31693 17.092 7.67231C17.4691 8.0277 17.4691 8.58769 17.092 8.94307L14.9094 11L17.092 13.0569Z"
        />
    </svg>
);
const NumbersKeypad = ({ onKeyPress }) => {
    const keys = [
        ['1', '2', '3'],
        ['4', '5', '6'],
        ['7', '8', '9'],
        ['clear', '0', 'backspace']
    ];

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {keys.map((row, rowIndex) => (
                <div key={rowIndex} style={{ display: 'flex', gap: '16px' }}>
                    {row.map((key) => (
                        <Button
                            key={key}
                            type="default"
                            size="large"
                            onClick={() => onKeyPress(key)}
                            icon={key === 'backspace' ? <CloseTagIcon /> : null}
                            style={{
                                width: '72px',
                                height: '72px',
                                fontSize: '24px',
                                lineHeight: '30px',
                                letterSpacing: '0.36px',
                                fontWeight: 'bold',
                                padding: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            {key === 'clear' ? 'C' : (key !== 'backspace' ? key : null)}
                        </Button>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default NumbersKeypad;
